import React from 'react'
import injectSheet from 'react-jss'
import styles from './head.styles'
import SubHead from '../../../sub-head/sub-head'
import { Link } from 'react-router-dom'
import LeftIcon from 'react-icons/lib/fa/caret-left'
import Button from 'pobble-components/dist/button'

const Head = ({ classes, title, onCopy, copying }) => (
  <SubHead className={classes.container}>
    <Link className={classes.backToLessons} to="/shared">
      <LeftIcon />
      Back to shared lessons list
    </Link>
    {title && (
      <p className={classes.title}>
        You are previewing&nbsp;<strong>{title}</strong>
      </p>
    )}
    <Button
      disabled={copying}
      action={onCopy}
      className={classes.copyButton}
      tall>
      {copying && 'Creating a copy'}
      {!copying && 'Create my copy'}
    </Button>
  </SubHead>
)

export default injectSheet(styles)(Head)
